import styled from 'styled-components/macro';

import { StyledWidthLimiter } from '../../../styles';

export const StyledMain = styled(StyledWidthLimiter).attrs({ as: 'main' })`
    flex-grow: 1;
`;
